import Icon from '../components/Icon.vue'

Icon.register({
  'frown-open': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM136 208C136 190.3 150.3 176 168 176S200 190.3 200 208 185.7 240 168 240 136 225.7 136 208zM323.3 391.3C292.1 381.7 263.9 376 248 376S203.9 381.7 172.7 391.3C161.2 394.8 150.2 385 152.2 373.2 159.2 333.2 212.3 312 248 312S336.8 333.3 343.8 373.2C345.8 385.1 334.7 394.8 323.3 391.3zM328 240C310.3 240 296 225.7 296 208S310.3 176 328 176 360 190.3 360 208 345.7 240 328 240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/frown-open.js
// module id = 1VCY
// module chunks = 144